import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";
import contentConfig from "../content.config.json";
import "../Styles/Navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const navContent = contentConfig.navbar;
  const isHomePage = location.pathname === '/';

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close mobile menu on window resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1024) {
        setMenuOpen(false);
        document.body.style.overflow = "unset";
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Manage body scroll when menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [menuOpen]);

  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <>
      <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""} ${!isHomePage ? "navbar--scrolled" : ""}`}>
        <div className="navbar__container">
          {/* Logo */}
          <Link to="/" className="navbar__logo" onClick={closeMenu}>
            <img
              src={navContent.logoPathLight}
              alt={navContent.logoAlt}
              className="navbar__logo-image navbar__logo-image--light"
            />
            <img
              src={navContent.logoPathDark}
              alt=""
              aria-hidden="true"
              className="navbar__logo-image navbar__logo-image--dark"
            />
            {navContent.wordmark && (
              <span className="navbar__wordmark">{navContent.wordmark}</span>
            )}
          </Link>

          {/* Desktop Navigation */}
          <ul className="navbar__menu">
            {navContent.navigationLinks
              .sort((a, b) => a.order - b.order)
              .map((link) => (
                <li key={link.id} className="navbar__menu-item">
                  <Link
                    to={link.path}
                    className={`navbar__link ${
                      location.pathname === link.path ? "navbar__link--active" : ""
                    }`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
          </ul>

          {/* CTA Button (Desktop) */}
          {navContent.ctaButton.visible && (
            <Link 
              to={navContent.ctaButton.path} 
              className="navbar__cta"
            >
              {navContent.ctaButton.label}
            </Link>
          )}

          {/* Mobile Menu Toggle */}
          <button
            className="navbar__toggle"
            onClick={handleMenuToggle}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
          >
            {menuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div className={`mobile-menu ${menuOpen ? "mobile-menu--open" : ""}`}>
        <div className="mobile-menu__content">
          <ul className="mobile-menu__list">
            {navContent.navigationLinks
              .sort((a, b) => a.order - b.order)
              .map((link) => (
                <li key={link.id} className="mobile-menu__item">
                  <Link
                    to={link.path}
                    className={`mobile-menu__link ${
                      location.pathname === link.path ? "mobile-menu__link--active" : ""
                    }`}
                    onClick={closeMenu}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
          </ul>

          {/* CTA Button (Mobile) */}
          {navContent.ctaButton.visible && (
            <Link 
              to={navContent.ctaButton.path} 
              className="mobile-menu__cta"
              onClick={closeMenu}
            >
              {navContent.ctaButton.label}
            </Link>
          )}
        </div>
      </div>
    </>
  );
};

export default Navbar;